import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

/**
 * Signal-based toast queue. The <app-toast> component renders `messages()`.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _messages = signal<Toast[]>([]);
  readonly messages = this._messages.asReadonly();

  private nextId = 1;
  private readonly ttlMs = 4500;

  success(message: string): void {
    this.push('success', message);
  }

  error(message: string): void {
    this.push('error', message);
  }

  info(message: string): void {
    this.push('info', message);
  }

  dismiss(id: number): void {
    this._messages.update((list) => list.filter((t) => t.id !== id));
  }

  private push(type: ToastType, message: string): void {
    const id = this.nextId++;
    this._messages.update((list) => [...list, { id, type, message }]);
    setTimeout(() => this.dismiss(id), this.ttlMs);
  }
}
